export default [
  {
    id: 1,
    label: 'VPA#',
    field_name: 'vpa_number',
    source_field: 'vpa_number',
    showColumn: true,
  },
  {
    id: 2,
    label: 'Date',
    field_name: 'date',
    source_field: 'completed_at',
    type: 'date',
    showColumn: true,
  },
  {
    id: 3,
    label: 'Overall Score',
    field_name: 'overall_score',
    source_field: 'overall_score',
    showColumn: false,
  },
  {
    id: 4,
    label: 'Overall Level',
    field_name: 'overall_level',
    source_field: 'overall_level',
    showColumn: true,
  },
  {
    id: 5,
    label: 'Reading Score',
    field_name: 'reading_score',
    source_field: 'reading_score',
    showColumn: true,
  },
  {
    id: 6,
    label: 'Reading Level',
    field_name: 'reading_level',
    source_field: 'reading_level',
    showColumn: true,
  },
  {
    id: 7,
    label: 'Grammar Score',
    field_name: 'grammar_score',
    source_field: 'grammar_score',
    showColumn: true,
  },
  {
    id: 8,
    label: 'Grammar Level',
    field_name: 'grammar_level',
    source_field: 'grammar_level',
    showColumn: false,
  },
  {
    id: 9,
    label: 'Listening Score',
    field_name: 'listening_score',
    source_field: 'listening_score',
    showColumn: false,
  },
  {
    id: 10,
    label: 'Listening Level',
    field_name: 'listening_level',
    source_field: 'listening_level',
    showColumn: true,
  },
  {
    id: 11,
    label: 'Speaking Score',
    field_name: 'speaking_score',
    source_field: 'speaking_score',
    showColumn: false,
  },
  {
    id: 12,
    label: 'Speaking Level',
    field_name: 'speaking_level',
    source_field: 'speaking_level',
    showColumn: false,
  },
];
